/**
 * Miansai — Nosto cart drawer recommendation sync
 * Placement: cartpage-nosto-1
 *
 * Fixes:
 * - Recommendations refresh after cart add / change / remove
 * - Cart items excluded on reload (via includeTagging: true)
 * - Initial load when cart drawer opens
 */
(function () {
  'use strict';

  var PLACEMENT_ID = 'cartpage-nosto-1';
  var RELOAD_DEBOUNCE_MS = 350;
  var reloadTimer = null;
  var reloadInFlight = false;
  var reloadQueued = false;

  function hasJQuery() {
    return typeof window.jQuery === 'function';
  }

  function placementNode() {
    return document.getElementById(PLACEMENT_ID);
  }

  function invokeNosto(callback) {
    if (typeof window.nostojs !== 'function') return false;

    window.nostojs(function (api) {
      callback(api);
    });

    return true;
  }

  function reloadPlacement(api) {
    if (!api || !placementNode()) return Promise.resolve();

    if (typeof api.createRecommendationRequest === 'function') {
      return api
        .createRecommendationRequest({ includeTagging: true })
        .setElements([PLACEMENT_ID])
        .load();
    }

    if (typeof api.loadRecommendations === 'function') {
      api.loadRecommendations();
    }

    return Promise.resolve();
  }

  function runReload() {
    if (!placementNode()) return;

    if (reloadInFlight) {
      reloadQueued = true;
      return;
    }

    reloadInFlight = true;

    var done = function () {
      reloadInFlight = false;
      if (reloadQueued) {
        reloadQueued = false;
        scheduleReload(0);
      }
    };

    if (!invokeNosto(function (api) {
      Promise.resolve(reloadPlacement(api)).then(done).catch(done);
    })) {
      reloadInFlight = false;
    }
  }

  function scheduleReload(delay) {
    if (!placementNode()) return;
    clearTimeout(reloadTimer);
    reloadTimer = window.setTimeout(runReload, typeof delay === 'number' ? delay : RELOAD_DEBOUNCE_MS);
  }

  function isCartDrawerOpen() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    if (drawer.classList.contains('drawer--is-open') || drawer.classList.contains('is-open')) return true;
    if (document.documentElement.classList.contains('js-drawer-open')) return true;
    return drawer.getAttribute('aria-hidden') === 'false';
  }

  function bindAjaxCartReload() {
    if (!hasJQuery()) return;

    window.jQuery(document.body).on('afterCartLoad.ajaxCart.miansaiNosto', function () {
      scheduleReload();
    });
  }

  function bindDrawerOpenReload() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest(
        '.js-drawer-open-right, .js-drawer-open-cart, .site-header__cart-toggle, [aria-controls="CartDrawer"]'
      );
      if (!opener) return;
      scheduleReload(500);
    }, true);

    var drawer = document.getElementById('CartDrawer');
    if (!drawer || typeof window.MutationObserver !== 'function') return;

    var observer = new window.MutationObserver(function () {
      if (isCartDrawerOpen()) scheduleReload(300);
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function bindFetchFallback() {
    if (typeof window.fetch !== 'function') return;

    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?/i.test(url);

      return originalFetch(input, init).then(function (response) {
        if (isCartMutation && response && response.ok) {
          scheduleReload();
        }
        return response;
      });
    };
  }

  function init() {
    bindAjaxCartReload();
    bindDrawerOpenReload();
    bindFetchFallback();

    if (isCartDrawerOpen()) {
      scheduleReload(400);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
